import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Rules } from 'Validation';
import BaseFormRow from 'CheckoutForm/components/FormRow/BaseFormRow';


export default class PasswordFormField extends React.Component {
  constructor(props) {
    super(props);

    this.getPasswordFormField = this.getPasswordFormField.bind(this);
  }

  getPasswordFormField() {
    const enablePassword = this.props.enabled;
    const passwordFormClasses = classNames(
      'password-form-field',
      'control-group',
      {
        disabled: !enablePassword,
      },
    );
    const passwordValidationProps = {
      type: 'password',
      name: 'password',
      id: 'password',
      className: 'required input-xlarge',
      disabled: !enablePassword,
      placeholder: this.props.passwordPlaceholder,
      autoComplete: 'off',
      validations: this.props.validations,
    };
    return (
      <BaseFormRow
        formClasses={passwordFormClasses}
        inputClasses="controls"
        htmlFor="password"
        label="Password:"
        stateKey="password"
        value=""
        validationProps={passwordValidationProps}
        onChange={this.props.onPasswordChange}
      />
    );
  }

  render() {
    const passwordFormField = this.getPasswordFormField();
    return passwordFormField;
  }
}


PasswordFormField.defaultProps = {
  enabled: true,
  onPasswordChange: () => {},
  passwordPlaceholder: '',
  validations: [Rules.required],
};

PasswordFormField.propTypes = {
  enabled: PropTypes.bool,
  onPasswordChange: PropTypes.func,
  passwordPlaceholder: PropTypes.string,
  validations: PropTypes.arrayOf(PropTypes.func),
};



// WEBPACK FOOTER //
// ./src-react/RegisterForm/components/PasswordFormField/index.jsx